<template>
  <div class="popup" v-cloak v-if="readdShow">
      <div class="content" id="readdRealTime">
            <div class="title">
                 {{$t('language.cloudBackup.readdCloud')}}
                 <div class="icon white-close dialog-close" @click="readdShow=false"></div>
            </div>
            <div class="readd-body">
                   <div class="readd-info">
                        <span v-if="this.source=='aim'">{{$t('language.cloudBackup.selectedHasAdded')}}</span>
                        <span v-else>{{$t('language.cloudBackup.selectedCloud')}}</span>
                       <!-- Some of the selected clouds was added to MultCloud before Cloud Backup released, we suggest to re-add the clouds to MultCloud and try again. -->
                   </div>
                   <div class="realtime-readd-bottom">
                        <button style="marginRight:25px;" @click="continueTask()" > {{$t('language.cloudBackup.continueAnyway')}}</button>
                        <button style="width:110Px;float:right;background:#fff;border:1px solid #7580c2;color:#7580c2;" @click.stop="sureTasK()"> {{$t('language.twoStepverification.cancel')}}</button>
                   </div>
            </div>
      </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data:function(){
        return{
            readdShow:false,
            isSure:false,
            isSelected:false,
            addData:null,
            source:'',//判断来源是源还是目标
            nodes:[],//用户选择的数据节点
        }
    },
    methods: {
        sureTasK(){
           this.readdShow = false;
        },
        continueTask(){
           
           if(this.source=='aim'){
          // this.$parent.$refs.transferAimsDialog.pass=[];
               for (let index = 0; index < this.nodes.length; index++) {
                const element = this.nodes[index];
                var driveId;
                if(element.driveInfo &&element.driveInfo.id){
                  driveId = element.driveInfo.id;
                }else{
                  driveId = element.driveId;
                }
                if(!this.$parent.$refs.transferAimsDialog.pass.includes(driveId)){
                    this.$parent.$refs.transferAimsDialog.pass.push(driveId);
                }
            }
           this.$parent.$refs.transferAimsDialog.singleSubmit();
           }else{
            //this.$parent.$refs.transferSourceDialog.pass=[];
            for (let index = 0; index < this.nodes.length; index++) {
                const element = this.nodes[index];
                var driveId;
                if(element.driveInfo && element.driveInfo.id){
                  driveId = element.driveInfo.id;
                }else{
                  driveId = element.driveId;
                }
                if(!this.$parent.$refs.transferSourceDialog.pass.includes(driveId)){
                    this.$parent.$refs.transferSourceDialog.pass.push(driveId);
                }
            }
           this.$parent.$refs.transferSourceDialog.multiSubmit();
           }
           this.readdShow =false;
        }

    },
    
}
</script>

<style>
#readdRealTime{
    width: 560Px;
    height: 220Px;
}
.readd-body{
    width: 100%;
    height: 180Px;
    padding: 20Px 10Px 10Px 10Px;
    box-sizing: border-box;
    text-align: left;
  
}
.readd-info{
    width: 100%;
    height:100Px;
    float: left;
}

.realtime-readd-bottom{
    width: 528Px;
    height: 40Px;
    float: left;
    display: flex;
    justify-content: center;

}
.noreaddcheck-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -20px -208px;
    /*no*/
}

.check-small {
    width: 15px;
    /*no*/
    height: 15px;
    /*no*/
    background-position: -88px -208px;
    /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/readd_cloud_popup.vue